export const EMAIL_PATTERN = /[a-zA-Z0-9äöüÄÖÜ_+.-]+@[a-zA-Z0-9-äöüÄÖÜ.]+\.([a-zA-Z]{2,6})$/;
export const PASSWORD_PATTERN = /^.{6,50}$/;
